
import GalleryTemplate from '~/components/common/product-gallery/gallery-template'
import GalleryMobile from '~/components/common/product-gallery/gallery-mobile'
import GalleryZoom from '~/components/common/product-gallery/gallery-zoom'

export default {
  components: {
    GalleryTemplate,
    GalleryMobile,
    GalleryZoom,
  },
  inject: ['bundle'],
  data() {
    return {
      showLoader: false,
      showZoom: false,
    }
  },
  computed: {
    medias() {
      return this.bundle.bundleGallery.map((media) => ({
        src: media?.filename,
        type: media?.type === 'video' ? 'video' : 'image',
      }))
    },
    product() {
      return {
        title: this.bundle.bundleTitle,
        normalized_color: this.bundle.color,
        model_size_data: this.bundle.modelSizeData,
        medias: this.medias,
      }
    },
  },
  methods: {
    openZoom(index) {
      this.showZoom = index + 1
      document.body.style.overflow = 'hidden'
    },
    closeZoom() {
      this.showZoom = false
      document.body.style.overflow = ''
    },
  },
}
